// Handle ResizeObserver loop limit exceeded error
const resizeObserverErrorHandler = () => {
  const handleError = (event) => {
    const message = event.message || event.error?.message;
    
    // Handle all ResizeObserver related errors
    if (message && (
      message.toString().includes('ResizeObserver loop limit exceeded') ||
      message.toString().includes('ResizeObserver loop completed with undelivered notifications')
    )) {
      // Prevent the error from being logged to the console
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  };

  // Add error event listener
  window.addEventListener('error', handleError);

  // Cleanup function
  return () => {
    window.removeEventListener('error', handleError);
  };
};

export default resizeObserverErrorHandler; 